<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
  <button
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="bsModalRef.hide()"
    (keydown.enter)="bsModalRef.hide()"></button>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  @if (options.length) {
    @for (option of options; track option) {
      <button
        [id]="'btn-modal-' + option"
        type="button"
        class="btn btn-primary"
        (click)="respond(option)"
        (keydown.enter)="respond(option)">
        {{ option }}
      </button>
    }
  }
</div>
